import _ from 'lodash';

const ASSETS_IN_PREFIX = 'assets-in';

const toAssetFilters = parts => {
  let assetFilters = [];

  if (parts.length > 1) {
    assetFilters = _.startsWith(parts[1], ASSETS_IN_PREFIX)
      ? parts[1].substring(ASSETS_IN_PREFIX.length + 1).split(',')
      : [parts[1]];
  }

  return assetFilters;
};

const urlToSearchCriteria = () => {
  const params = new URLSearchParams(window.location.search);
  const sortOrder = params.get('sort');
  const series = params.get('series');

  const parts = _.compact(window.location.pathname.split('/'));
  const type = parts[0] === 'funds' ? null : parts[0];
  const assetFilters = toAssetFilters(parts);

  return {
    type,
    assetFilters,
    sortOrder,
    series,
  };
};

const searchCriteriaToUrl = (type, assetFilters, sortOrder, series, companySlug) => {
  const filtersPath = assetFilters.length > 1
    ? `${ASSETS_IN_PREFIX}-${assetFilters.join(',')}`
    : assetFilters;

  const path = type || 'funds';
  let typeAndFiltersPath = _.join([window.location.origin, path, filtersPath], '/');
  if (companySlug) {
    typeAndFiltersPath += companySlug;
  }
  const searchParams = new URLSearchParams(new URL(typeAndFiltersPath).search);
  const urlParams = new URLSearchParams(window.location.search);
  const features = urlParams.get('features');
  if (sortOrder !== 'default') {
    searchParams.append('sort', sortOrder);
  }
  if (series !== null) {
    searchParams.append('series', series);
  }
  if (features !== null) {
    searchParams.append('features', features);
  }
  const parts = [typeAndFiltersPath, searchParams.toString()].filter(x => x);

  return _.join(parts, '?');
};

export {
  urlToSearchCriteria,
  searchCriteriaToUrl,
};
